import React from "react";
import { Link } from "react-router-dom";

const LandingBanner = () => {
  return (
    <>
      <div className="container-fluid">
        <div className="headecon_pad headecon_pad2">
          <div className="row row_header_flex">
            <div className="col-sm-6">
              <div className="ppcland_content ppcland_content2">
                <h4>
                  Pariksha Pe Charcha: Empowering Students, Enlightening Minds
                </h4>
                <div className="landing_link_div">
                  <Link to="/parikshapecharcha2025">
                    <img src="/assets/images/playchange.svg" alt="" /> Watch All
                    7 Episodes
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-sm-6">
              <div className="modippc_banner">
                <img
                  src="/assets/images/modi_lanfing.png"
                  className="modi_lan_banner"
                  alt=""
                />
                <div className="modi_banner_con">
                  <h4>
                  Join PM Narendra Modi along with domain experts as they interact with Exam Warriors for highly engaging sessions about managing time, stress, and much more during exams
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingBanner;
